import { Routes } from '@angular/router';
import { SiaMultiGridComponent } from './components/sia-multi-grid/sia-multi-grid.component';
import { SiaGridConfigPageComponent } from './pages/sia-grid-config-page/sia-grid-config-page.component';
import { SiaGridPageComponent } from './pages/sia-grid-page/sia-grid-page.component';
import { SiaMatGridConfiguratorPageComponent } from './pages/sia-mat-grid-configurator-page/sia-mat-grid-configurator-page.component';
import { SiaMatGridPageComponent } from './pages/sia-mat-grid-page/sia-mat-grid-page.component';
import { SiaMultiGridConfigurationComponent } from './pages/sia-multi-grid-configuration/sia-multi-grid-configuration.component';
export const ROUTES: Routes = [
  {
    path: 'grid/:gridId/:guid',
    component: SiaGridPageComponent,
  },
  {
    path: 'sia-grid/:gridId/:guid',
    component: SiaMatGridPageComponent,
  },
  {
    path: 'grid-config/:guid',
    component: SiaGridConfigPageComponent,
  },
  {
    path: 'multi-grid/:multiGridId/:guid',
    component: SiaMultiGridComponent,
  },
  {
    path: 'multi-grid-config/:guid',
    component: SiaMultiGridConfigurationComponent,
  },
  {
    path: 'mat-grid-config/:guid',
    component: SiaMatGridConfiguratorPageComponent,
  },
];
